<template>
  <main id="main-content">
    <div class="feature-landing-page">
      <ApiLoading
        v-if="!showHospitalTable && !showExtrasTable && (apiStatus.refData.loading || apiStatus.refData.fail || apiStatus.recordData.loading || apiStatus.recordData.fail)"
        :apiError="apiStatus.refData.fail || apiStatus.recordData.fail"
      />

      <!-- Header top section -->
      <template v-else>
        <div class="content-page-banner">
          <div class="banner-content">
            <h1>{{ $route.meta.title }}</h1>
            <div class="underline"></div>
            <div v-html="refData.waitingPeriodsInformationText.informationText" />
          </div>
        </div>

        <Tabs id="waiting-period-tabs" :tabs="tabTitles">
          <template v-slot="{ activeTab }">
            <!-- Extras/Hospital only waiting periods table -->
            <div v-if="activeTab === 0 && tabTitles.length === 1">
              <RecordsView
                :includeRecordHeader="false"
                class="records-view"
                :apiStatus="apiStatus"
                :referenceData="{}"
                :recordsData="waitingPeriodRecordData.extras"
                :includeFilter="true"
                :filterData="filterData.extras"
                :isCRM="false"
                @updatedFilterData="updateFilterData($event, true)"
                v-if="showExtrasTable"
                :linkColumnValue="null"
              >
                <template #filterHeader><h3>Filter by:</h3></template>
                <template v-slot:paragraphData>
                  <div
                    class="paragraph-data"
                    v-html="refData.extrasWaitingPeriodsInformationText.informationText"
                    v-if="refData.extrasWaitingPeriodsInformationText.informationText"
                  />
                </template>
                <template v-slot:pagination>
                  <Pagination
                    isSPA
                    @toPageNumber="changeExtrasTablePage"
                    :endPage="paginationParams.extras.lastPageNumber"
                    :currentPageFromParent="paginationParams.extras.pageNum"
                    :changeQueryString="false"
                  >
                    <template #paginationLabel>
                      <p v-if="waitingPeriodRecordData.extras.data.length">
                        {{
                          getPaginationDisplayLabel(
                            paginationParams.extras.pageNum,
                            paginationParams.extras.pageSize,
                            waitingPeriodRecordData.extras.data.length,
                            paginationParams.extras.totalNum,
                            paginationParams.extras.itemName,
                          )
                        }}
                      </p>
                    </template>
                  </Pagination>
                </template>
              </RecordsView>
              <RecordsView
                class="records-view"
                :includeRecordHeader="false"
                :apiStatus="apiStatus"
                :referenceData="{}"
                :recordsData="waitingPeriodRecordData.hospital"
                :includeFilter="true"
                :filterData="filterData.hospital"
                :isCRM="false"
                @updatedFilterData="updateFilterData($event)"
                v-if="showHospitalTable"
                :linkColumnValue="null"
              >
                <template #filterHeader><h3>Filter by:</h3></template>
                <template v-slot:paragraphData>
                  <div
                    class="paragraph-data"
                    v-if="refData.hospitalWaitingPeriodsInformationText.informationText"
                    v-html="refData.hospitalWaitingPeriodsInformationText.informationText"
                  />
                </template>
                <template v-slot:pagination>
                  <Pagination
                    isSPA
                    @toPageNumber="changeHospitalTablePage"
                    :endPage="paginationParams.hospital.lastPageNumber"
                    :currentPageFromParent="paginationParams.hospital.pageNum"
                    :changeQueryString="false"
                  >
                    <template #paginationLabel>
                      <p v-if="waitingPeriodRecordData.hospital.data.length">
                        {{
                          getPaginationDisplayLabel(
                            paginationParams.hospital.pageNum,
                            paginationParams.hospital.pageSize,
                            waitingPeriodRecordData.hospital.data.length,
                            paginationParams.hospital.totalNum,
                            paginationParams.hospital.itemName,
                          )
                        }}
                      </p>
                    </template>
                  </Pagination>
                </template>
              </RecordsView>
            </div>
            <!-- Extras waiting period table -->
            <div v-if="activeTab === 0 && tabTitles.length > 1">
              <RecordsView
                :includeRecordHeader="false"
                class="records-view"
                :apiStatus="apiStatus"
                :referenceData="{}"
                :recordsData="waitingPeriodRecordData.extras"
                :includeFilter="true"
                :filterData="filterData.extras"
                :isCRM="false"
                @updatedFilterData="updateFilterData($event, true)"
                v-if="showExtrasTable"
                :linkColumnValue="null"
              >
                <template #filterHeader><h3>Filter by:</h3></template>
                <template v-slot:paragraphData>
                  <div
                    class="paragraph-data"
                    v-html="refData.extrasWaitingPeriodsInformationText.informationText"
                    v-if="refData.extrasWaitingPeriodsInformationText.informationText"
                  />
                </template>
                <template v-slot:pagination>
                  <Pagination
                    isSPA
                    @toPageNumber="changeExtrasTablePage"
                    :endPage="paginationParams.extras.lastPageNumber"
                    :currentPageFromParent="paginationParams.extras.pageNum"
                    :changeQueryString="false"
                  >
                    <template #paginationLabel>
                      <p v-if="waitingPeriodRecordData.extras.data.length">
                        {{
                          getPaginationDisplayLabel(
                            paginationParams.extras.pageNum,
                            paginationParams.extras.pageSize,
                            waitingPeriodRecordData.extras.data.length,
                            paginationParams.extras.totalNum,
                            paginationParams.extras.itemName,
                          )
                        }}
                      </p>
                    </template>
                  </Pagination>
                </template>
              </RecordsView>
            </div>
            <!-- Hospital waiting period table -->
            <div v-if="activeTab === 1 && tabTitles.length > 1">
              <RecordsView
                class="records-view"
                :includeRecordHeader="false"
                :apiStatus="apiStatus"
                :referenceData="{}"
                :recordsData="waitingPeriodRecordData.hospital"
                :includeFilter="true"
                :filterData="filterData.hospital"
                :isCRM="false"
                @updatedFilterData="updateFilterData($event)"
                v-if="showHospitalTable"
                :linkColumnValue="null"
              >
                <template #filterHeader><h3>Filter by:</h3></template>
                <template v-slot:paragraphData>
                  <div
                    class="paragraph-data"
                    v-if="refData.hospitalWaitingPeriodsInformationText.informationText"
                    v-html="refData.hospitalWaitingPeriodsInformationText.informationText"
                  />
                </template>
                <template v-slot:pagination>
                  <Pagination
                    isSPA
                    @toPageNumber="changeHospitalTablePage"
                    :endPage="paginationParams.hospital.lastPageNumber"
                    :currentPageFromParent="paginationParams.hospital.pageNum"
                    :changeQueryString="false"
                  >
                    <template #paginationLabel>
                      <p v-if="waitingPeriodRecordData.hospital.data.length">
                        {{
                          getPaginationDisplayLabel(
                            paginationParams.hospital.pageNum,
                            paginationParams.hospital.pageSize,
                            waitingPeriodRecordData.hospital.data.length,
                            paginationParams.hospital.totalNum,
                            paginationParams.hospital.itemName,
                          )
                        }}
                      </p>
                    </template>
                  </Pagination>
                </template>
              </RecordsView>
            </div>
          </template>
        </Tabs>
      </template>
    </div>
  </main>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { sortBy } from 'lodash';
import { RecordsView, ApiLoading } from '@/components';
import { FilterTypes, WaitingPeriodServiceType } from '@/enums';
import { sortMembersByRelationshipDisplay, isEmptyString, getPaginationDisplayLabel } from '@/utils';
import { reverseFormatFormDate, firstLetterToUpperCase } from '@general/js/utils';
import { Pagination, Tabs } from '@general/js/components';
import Services from '@/services/WaitingPeriods';
import { VUEX_GENERAL, VUEX_WAITING_PERIODS } from '@/constants/VuexConstants';
import { CLAIMS_MAKE_A_CLAIM } from '@/router/routeNames';

const SERVICES_DROPDOWN_DEFAULT_OPTION = 'All service groups';
const HOSPITAL_TABLE_HEADINGS = ['Services', 'Waiting period', 'Waiting period end date', 'Pre-existing waiting period', 'Pre-existing waiting period end date', 'Waiver reason'];
const EXTRAS_TABLE_HEADINGS = ['Services', 'Waiting period', 'Waiting period end date', 'Waiver reason'];
const NO_RECORDS_TEXT = 'You do not have any waiting periods to be displayed currently.';
const AMBULANCE_SERVICE_CODE = 'EXT_AMB';

export default {
  name: 'WaitingPeriod',

  components: {
    RecordsView,
    Pagination,
    ApiLoading,
    Tabs,
  },

  data() {
    return {
      showHospitalTable: false,
      showExtrasTable: false,
      apiStatus: {
        refData: {
          fail: false,
          loading: false,
        },
        recordData: {
          fail: false,
          loading: false,
        },
      },
      filterData: {
        hospital: {
          filterName: '',
          filterFunction: this.applyHospitalFilters,
          filterOptions: [],
          filterDropdownData: [],
          filterNoRecordsText: 'We cannot find any records that match your search. Please adjust your search criteria and try again.',
        },
        extras: {
          filterName: '',
          filterFunction: this.applyExtrasFilters,
          filterOptions: [],
          filterDropdownData: [],
          filterNoRecordsText: 'We cannot find any records that match your search. Please adjust your search criteria and try again.',
        },
      },
      waitingPeriodRecordData: {
        hospital: {
          headings: HOSPITAL_TABLE_HEADINGS,
          data: [],
          noRecordsText: NO_RECORDS_TEXT,
        },
        extras: {
          headings: EXTRAS_TABLE_HEADINGS,
          data: [],
          noRecordsText: NO_RECORDS_TEXT,
        },
        filteredHospitalData: [],
        filteredExtrasData: [],
      },
      // dropdown data for both hospital and extras table's member & services filters
      dropdownData: {
        members: [],
        hospitalServices: [],
        extrasServices: [],
      },
      paginationParams: {
        hospital: {
          pageNum: 1,
          pageSize: 10,
          totalNum: 0,
          lastPageNumber: 1,
          itemName: 'hospital services',
        },
        extras: {
          pageNum: 1,
          pageSize: 10,
          totalNum: 0,
          lastPageNumber: 1,
          itemName: 'extras services',
        },
      },
      order: ['servicesDescription', 'serviceType', 'served', 'lengthOfWait', 'description'],
      refData: {
        waitingPeriodsCalloutText: {},
        waitingPeriodsInformationText: {},
        hospitalWaitingPeriodsInformationText: {},
        extrasWaitingPeriodsInformationText: {},
      },
      CLAIMS_MAKE_A_CLAIM,
    };
  },

  beforeMount() {
    this.fetchRecordsData();
    this.fetchRefData();
  },

  watch: {
    'paginationParams.hospital.pageNum': function (pageNum) {
      // Update table data when page number changes
      if (this.waitingPeriodRecordData.filteredHospitalData.length > 0) {
        this.waitingPeriodRecordData.hospital.data = this.waitingPeriodRecordData.filteredHospitalData.slice(
          (pageNum - 1) * this.paginationParams.hospital.pageSize,
          pageNum * this.paginationParams.hospital.pageSize,
        );
      } else {
        this.waitingPeriodRecordData.hospital.data = this.waitingPeriodRecordData.hospital.data.slice(
          (pageNum - 1) * this.paginationParams.hospital.pageSize,
          pageNum * this.paginationParams.hospital.pageSize,
        );
      }
    },
    'paginationParams.extras.pageNum': function (pageNum) {
      // Update table data when page number changes
      if (this.waitingPeriodRecordData.filteredExtrasData.length > 0) {
        this.waitingPeriodRecordData.extras.data = this.waitingPeriodRecordData.filteredExtrasData.slice(
          (pageNum - 1) * this.paginationParams.extras.pageSize,
          pageNum * this.paginationParams.extras.pageSize,
        );
      } else {
        this.waitingPeriodRecordData.extras.data = this.waitingPeriodRecordData.extras.data.slice(
          (pageNum - 1) * this.paginationParams.extras.pageSize,
          pageNum * this.paginationParams.extras.pageSize,
        );
      }
    },
  },

  computed: {
    ...mapGetters({
      memberNumber: VUEX_GENERAL.GETTERS.getCurrentPolicyNumber,
      membershipInfo: VUEX_GENERAL.GETTERS.getMembershipInfo,
    }),
    ...mapGetters('WaitingPeriods', {
      waitingPeriods: VUEX_WAITING_PERIODS.GETTERS.getWaitingPeriods,
      membersList: VUEX_WAITING_PERIODS.GETTERS.getMemberList,
    }),

    tabTitles() {
      const tabTitles = [];

      if (this.showExtrasTable) {
        tabTitles.push({ title: 'Extras' });
      }

      if (this.showHospitalTable) {
        tabTitles.push({ title: 'Hospital' });
      }

      return tabTitles;
    },
  },

  methods: {
    ...mapMutations('WaitingPeriods', {
      updateMembersList: VUEX_WAITING_PERIODS.MUTATIONS.updateMembersList,
      updateWaitingPeriods: VUEX_WAITING_PERIODS.MUTATIONS.updateWaitingPeriods,
    }),

    async fetchRefData() {
      try {
        this.apiStatus.refData.loading = true;
        this.apiStatus.refData.fail = false;

        const waitingPeriodsRefDataApiResponse = await Services.getWaitingPeriodsReferenceData();
        this.refData = waitingPeriodsRefDataApiResponse;
      } catch (error) {
        this.apiStatus.refData.fail = true;
        logger.log(error?.message ?? error);
      } finally {
        this.apiStatus.refData.loading = false;
      }
    },

    async fetchRecordsData() {
      try {
        this.apiStatus.recordData.loading = true;
        this.apiStatus.recordData.fail = false;

        const waitingPeriodsApiResponse = await Services.getWaitingPeriods(this.memberNumber);

        // Update waiting periods response into vuex store before we touch it.
        this.updateWaitingPeriods(waitingPeriodsApiResponse);

        // Setup all dropdowns
        this.setupTables(waitingPeriodsApiResponse);

        // update record data into tables
        this.tableDataInit(waitingPeriodsApiResponse);

        // Determine which table(s) to show
        // If waitingPeriodsApiResponse.memberList array has even one item in the `waitingPeriods` array with `serviceType` of 'C', show hospital table
        this.showHospitalTable = waitingPeriodsApiResponse.membersList.some((member) => {
          return member.waitingPeriods.some((period) => {
            return period.serviceType === WaitingPeriodServiceType.CLINICAL_CATEGORY;
          });
        });

        // If waitingPeriodsApiResponse.memberList array has even one item in the `waitingPeriods` array with `serviceType` of 'M', show extras table
        this.showExtrasTable = waitingPeriodsApiResponse.membersList.some((member) => {
          return member.waitingPeriods.some((period) => {
            return period.serviceType === WaitingPeriodServiceType.MODALITY;
          });
        });
      } catch (error) {
        this.apiStatus.recordData.fail = true;
        logger.log(error?.message ?? error);
      } finally {
        this.apiStatus.recordData.loading = false;
      }
    },

    setupTables(waitingPeriods) {
      // Need to call this function to populate this.membersList in vuex store before we can setup dropdowns
      this.setupMembersList(waitingPeriods);

      // Setup member dropdown list
      if (this.membersList && this.membersList.length) {
        this.dropdownData.members = sortMembersByRelationshipDisplay(this.membersList, 'coveredOnMembership', 'name', 'ascending', this.membershipInfo.composition);
      }

      // Setup hospital and extras table services dropdown list - we need to collect all waiting periods for all members first
      const allWaitingPeriodsForAllMembers = [];

      waitingPeriods.membersList.forEach((member) => {
        allWaitingPeriodsForAllMembers.push(...member.waitingPeriods);
      });

      // Setup hospital services dropdown list
      this.dropdownData.hospitalServices = [
        ...new Set(
          this.filterHospitalWaitingPeriods(allWaitingPeriodsForAllMembers).map((obj) => {
            return obj.servicesDescription;
          }),
        ),
      ].sort();

      // Setup extras table services dropdown list
      this.dropdownData.extrasServices = [
        ...new Set(
          this.filterExtrasWaitingPeriods(allWaitingPeriodsForAllMembers).map((obj) => {
            return obj.servicesDescription;
          }),
        ),
      ].sort();

      this.dropdownData.hospitalServices.unshift(SERVICES_DROPDOWN_DEFAULT_OPTION); // add default option
      this.dropdownData.extrasServices.unshift(SERVICES_DROPDOWN_DEFAULT_OPTION); // add default option

      // Setup table filters (can only be done after dropdown lists are setup as above)
      this.setupTableFilters(this.filterData.hospital, this.dropdownData.hospitalServices);
      this.setupTableFilters(this.filterData.extras, this.dropdownData.extrasServices);
    },

    // This function will update the dropdowns with the member names list and the services list for hospital and extras table
    setupTableFilters(filterData, servicesDropdownData) {
      filterData.filterOptions = [
        {
          filterHeading: 'Member',
          filterType: FilterTypes.DROPDOWN_INPUT,
          filterPlaceholder: this.dropdownData.members[0].name,
          filterDropdownData: this.dropdownData.members.map((member) => {
            return member.name;
          }),
          filterResult: this.dropdownData.members[0].name,
        },
        {
          filterHeading: 'Services',
          filterType: FilterTypes.DROPDOWN_INPUT,
          filterPlaceholder: SERVICES_DROPDOWN_DEFAULT_OPTION,
          filterDropdownData: servicesDropdownData,
          filterResult: SERVICES_DROPDOWN_DEFAULT_OPTION,
        },
      ];
    },

    // this function updates the membersList in vuex store
    setupMembersList(response) {
      const membersList = [];

      // iterate through waitingPeriodsForEachMember.membersList array and add each member's `firstName`, `lastName`, `coveredOnMembership` & `personCode` to membersList array
      response.membersList.forEach((member) => {
        membersList.push({
          firstName: member.firstName,
          lastName: member.lastName,
          coveredOnMembership: member.coveredOnMembership,
          personCode: member.personCode,
          name: `${member.firstName} ${member.lastName}`,
        });
      });

      // Update membersList in vuex
      this.updateMembersList(membersList);
    },

    // This function return an array of waiting periods with `serviceType` of 'C' (clinical category) and the Ambulance service
    filterHospitalWaitingPeriods(waitingPeriodsArr) {
      return waitingPeriodsArr.filter((period) => {
        return (
          period.serviceType === WaitingPeriodServiceType.CLINICAL_CATEGORY || (isEmptyString(period.serviceType) && period.serviceOptionServiceCode === AMBULANCE_SERVICE_CODE)
        );
      });
    },

    // This function return an array of waiting periods with `serviceType` of 'M' (modality) and the Ambulance service
    filterExtrasWaitingPeriods(waitingPeriodsArr) {
      return waitingPeriodsArr.filter((period) => {
        return period.serviceType === WaitingPeriodServiceType.MODALITY || (isEmptyString(period.serviceType) && period.serviceOptionServiceCode === AMBULANCE_SERVICE_CODE);
      });
    },

    // This function is called when the page is first loaded to populate the table data
    tableDataInit(waitingPeriodsData) {
      // Init table with data for first user in dropdown list (defaults to policy holder(if one exists) based on sorting)
      const firstMembersWaitingPeriods = waitingPeriodsData.membersList.find((member) => {
        return member.personCode === this.dropdownData.members[0].personCode;
      });

      this.updateDataForHospitalTable(firstMembersWaitingPeriods.waitingPeriods);
      this.updateDataForExtrasTable(firstMembersWaitingPeriods.waitingPeriods);
    },

    // This function receives a waitingPeriodsArr array, it then sorts it and puts into required structure for hospital table.
    updateDataForHospitalTable(waitingPeriodsArr) {
      const sortedWaitingPeriods = this.sortRecordData(this.filterHospitalWaitingPeriods(waitingPeriodsArr), this.order);

      const waitingPeriodData = this.transformWaitingPeriodsArrayIntoHospitalTableColumns(sortedWaitingPeriods);

      // store full filtered data
      this.waitingPeriodRecordData.filteredHospitalData = waitingPeriodData;

      // only display first page
      this.waitingPeriodRecordData.hospital.data = waitingPeriodData.slice(0, this.paginationParams.hospital.pageSize);

      this.paginationParams.hospital.totalNum = waitingPeriodData.length;
      this.paginationParams.hospital.lastPageNumber = Math.ceil(waitingPeriodData.length / this.paginationParams.hospital.pageSize);
    },

    // This function receives a waitingPeriodsArr array, it then sorts it and puts into required structure for extras table.
    updateDataForExtrasTable(waitingPeriodsArr) {
      const sortedWaitingPeriods = this.sortRecordData(this.filterExtrasWaitingPeriods(waitingPeriodsArr), this.order);

      const waitingPeriodData = this.transformWaitingPeriodsArrayIntoExtrasTableColumns(sortedWaitingPeriods);

      // store full filtered data
      this.waitingPeriodRecordData.filteredExtrasData = waitingPeriodData;

      // only display first page
      this.waitingPeriodRecordData.extras.data = waitingPeriodData.slice(0, this.paginationParams.extras.pageSize);
      this.paginationParams.extras.totalNum = waitingPeriodData.length;
      this.paginationParams.extras.lastPageNumber = Math.ceil(waitingPeriodData.length / this.paginationParams.extras.pageSize);
    },

    /**
     * Sorts object in ascending order depending on priority using lodash sortBy
     * @param {obj} data
     * @param {string[]} priority
     */
    sortRecordData(data, priority) {
      const sorted = sortBy(data, priority);
      return sorted;
    },

    // End date can either be: '', 'YYYY-MM-DD' or 'served', this functions transforms this value to presentable format
    getWaitingPeriodEndDate(periodEndDate) {
      if (isEmptyString(periodEndDate)) {
        return 'Not applicable';
      }

      if (periodEndDate === 'served') {
        return firstLetterToUpperCase(periodEndDate);
      }

      return reverseFormatFormDate(periodEndDate);
    },

    // This function formats the received waiting periods array into an array of objects that can be used to populate the hospital table(based on column names)
    transformWaitingPeriodsArrayIntoHospitalTableColumns(waitingPeriodArr) {
      // Given an array of waiting period objects, this function returns an array of formatted objects that can be used to populate the hospital table (i.e in key/value format where key=table column name and value=table cell value)
      return waitingPeriodArr.map((obj) => {
        return {
          Services: obj.servicesDescription,
          'Waiting period': Number(obj?.lengthOfWait) > 0 ? `${obj.lengthOfWait} months` : '-',
          'Waiting period end date': this.getWaitingPeriodEndDate(obj.periodEndDate),
          'Pre-existing waiting period': obj.preWaitPeriodLength === null ? 'Not applicable' : `${obj.preWaitPeriodLength} months`,
          'Pre-existing waiting period end date': this.getWaitingPeriodEndDate(obj.preWaitPeriodEndDate),
          'Waiver reason': obj.waiverReason,
          Type: obj.serviceType,
          ServiceOptionId: obj.id,
        };
      });
    },

    // This function formats the received waiting periods array into an array of objects that can be used to populate the extras table(based on column names)
    transformWaitingPeriodsArrayIntoExtrasTableColumns(waitingPeriodArr) {
      // Given an array of waiting period objects, this function returns an array of formatted objects that can be used to populate the extras table (i.e in key/value format where key=table column name and value=table cell value)
      return waitingPeriodArr.map((obj) => {
        return {
          Services: obj.servicesDescription,
          'Waiting period': Number(obj?.lengthOfWait) > 0 ? `${obj.lengthOfWait} months` : '-',
          'Waiting period end date': this.getWaitingPeriodEndDate(obj.periodEndDate),
          'Waiver reason': obj.waiverReason,
          Type: obj.serviceType,
          ServiceOptionId: obj.id,
        };
      });
    },

    // This function is called every time a filter value is changed, but before the filter is applied using `Apply` button
    updateFilterData(filterData, isExtrasTable = false) {
      if (isExtrasTable) {
        this.filterData.extras = filterData;
      } else {
        this.filterData.hospital = filterData;
      }
    },

    // This function is called when the `Apply` button is clicked to apply the filters in the HOSPITAL table
    applyHospitalFilters() {
      const filteredWaitingPeriods = this.applyFilter();
      this.updateDataForHospitalTable(filteredWaitingPeriods);
      // Reset to page 1 after applying filter
      this.changeHospitalTablePage(1);
    },

    // This function is called when the `Apply` button is clicked to apply the filters in the EXTRAS table
    applyExtrasFilters() {
      const filteredWaitingPeriods = this.applyFilter(true);
      this.updateDataForExtrasTable(filteredWaitingPeriods);
      // Reset to page 1 after applying filter
      this.changeExtrasTablePage(1);
    },

    // This is a helper function that is called by appyHospitalFilters() and applyExtrasFilters() to apply the filters
    applyFilter(isExtrasTable = false) {
      let currentTable = 'hospital';
      if (isExtrasTable) {
        currentTable = 'extras';
      }

      const memberFilterValue = this.filterData[currentTable].filterOptions[0].filterResult
        ? this.filterData[currentTable].filterOptions[0].filterResult
        : this.filterData[currentTable].filterOptions[0].filterPlaceholder;

      const servicesFilterValue = this.filterData[currentTable].filterOptions[1].filterResult
        ? this.filterData[currentTable].filterOptions[1].filterResult
        : this.filterData[currentTable].filterOptions[1].filterPlaceholder;

      const selectedMemberObj = this.dropdownData.members.find((member) => {
        return member.name === memberFilterValue;
      });

      let waitingPeriodsForSelectedMember = this.waitingPeriods.membersList.find((member) => {
        return member.personCode === selectedMemberObj.personCode;
      })?.waitingPeriods;

      if (servicesFilterValue !== SERVICES_DROPDOWN_DEFAULT_OPTION) {
        waitingPeriodsForSelectedMember = waitingPeriodsForSelectedMember.filter((period) => {
          return period.servicesDescription === servicesFilterValue;
        });
      }

      return waitingPeriodsForSelectedMember;
    },

    // This function is called when page is changed in the hospital table
    changeHospitalTablePage(pageNum) {
      this.paginationParams.hospital.pageNum = Number(pageNum);
    },

    // This function is called when page is changed in the extras table
    changeExtrasTablePage(pageNum) {
      this.paginationParams.extras.pageNum = Number(pageNum);
    },

    getPaginationDisplayLabel,
  },
};
</script>

<style lang="scss" scoped>
.records-view {
  :deep(.filter-group) {
    .filter-buttons {
      grid-row: 2;
    }
  }
}

.select-white {
  :deep(label) {
    background-color: $WHITE !important;
  }
}

.paragraph-data {
  margin-bottom: rem(45);
}

.top-section {
  display: flex;
  flex-direction: row;
  column-gap: 5%;
  margin-bottom: spacer(3);

  * {
    flex: 1;
  }

  @include mobile {
    flex-direction: column;
  }
}
</style>
